import React, { useState } from 'react';
import Navbar from './Navbar';
import Sidebar from './Sidebar';

function Layout({ children }) {
    const [sidebarOpen, setSidebarOpen] = useState(false);

    const toggleSidebar = () => {
        setSidebarOpen(!sidebarOpen);
    };

    return (
        <div className="d-flex flex-column vh-100 overflow-hidden">
            <Navbar toggleSidebar={toggleSidebar} />
            <div className="d-flex flex-grow-1 overflow-hidden position-relative">
                <Sidebar isOpen={sidebarOpen} toggleSidebar={toggleSidebar} />
                <main className="flex-grow-1 p-3 overflow-auto transition-all">
                    {children}
                </main>
                {/* Overlay for mobile when sidebar is open */}
                {sidebarOpen && (
                    <div 
                        className="overlay d-md-none" 
                        onClick={toggleSidebar}
                    ></div>
                )}
            </div>
        </div>
    );
}

export default Layout;
